export default class Features {
	public static readonly Acs: string = "Acs";
	public static readonly ScheduledQueue: string = "ScheduledQueue";
	public static readonly BookingsScheduledQueue: string = "BookingsScheduledQueue";
	public static readonly InternalAssistant: string = "InternalAssistant";
	public static readonly GovBrAuthentication: string = "GovBrAuthentication";
	public static readonly RecordingGovernance: string = "RecordingGovernance";
	public static readonly UserQueueAttachments: string = "UserQueueAttachments";
	public static readonly ChatAttendance: string = "ChatAttendance";
}